import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect, useState } from 'react';
import WidgetFrame from '@fandom-frontend/react-common/dist/components/WidgetFrame';
import CardHorizontal from '@fandom-frontend/react-common/dist/components/CardHorizontal';
import { useOnScreenCallback } from '../shared/useOnScreen';
import '@fandom-frontend/react-common/dist/components/WidgetFrame.css';
import '@fandom-frontend/react-common/dist/components/CardHorizontal.css';
import { isTextOverflowing } from 'pathfinder/modules/shared/utils/isTextOverflowing';
import { getUserActiveModules } from 'pathfinder/utils/shareState/getUserActiveModules';
import { NEW_POPULAR_PAGES_VARIANT } from 'pathfinder/rules-engine/modules/newPopularPages';
import styles from './NewPopularPages.module.scss';
const NewPopularPagesModule = ({ log, track }) => {
    var _a;
    const [onScreen, wrapperRef] = useOnScreenCallback();
    const [popularPagesElements, setPopularPagesElements] = useState([]);
    const [impressionTracked, setImpressionTracked] = useState(false);
    const extractTextContent = (element, selector, defaultValue = '') => { var _a; return ((_a = element.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.textContent) || defaultValue; };
    const extractAttribute = (element, selector, attribute, defaultValue = '') => { var _a; return ((_a = element.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.getAttribute(attribute)) || defaultValue; };
    const popularPagesTitle = ((_a = document.querySelector('.popular-pages > .rail-module__header')) === null || _a === void 0 ? void 0 : _a.textContent) || 'Popular Pages';
    useEffect(() => {
        const getPopularPagesElements = () => {
            const popularPagesElements = Array.from(document.querySelectorAll('.popular-pages .popular-pages__item'));
            const newPopularPagesElements = popularPagesElements.map((element) => {
                const isSponsoredContent = element.querySelector('.sponsored-content') !== null;
                return {
                    title: isSponsoredContent
                        ? extractTextContent(element, '.sponsored-content__title')
                        : extractAttribute(element, 'img', 'alt'),
                    image: extractAttribute(element, 'img', 'src'),
                    link: extractAttribute(element, 'a', 'href'),
                    subtext: isSponsoredContent
                        ? extractTextContent(element, '.sponsored-content__attribution', undefined)
                        : undefined,
                    hasLongTitle: isSponsoredContent
                        ? isTextOverflowing(element.querySelector('.sponsored-content__title'))
                        : false,
                    hasLongSubtext: isSponsoredContent
                        ? isTextOverflowing(element.querySelector('.sponsored-content__attribution'))
                        : false,
                };
            });
            setPopularPagesElements(newPopularPagesElements);
        };
        getPopularPagesElements();
    }, []);
    useEffect(() => {
        if (onScreen && !impressionTracked) {
            track.impression({ label: 'right-rail-popular-pages' });
            log.debug('NewPopularPagesModule loaded');
            setImpressionTracked(true);
        }
    }, [onScreen]);
    const shouldRenderVariant = getUserActiveModules().some((module) => module.name === NEW_POPULAR_PAGES_VARIANT.ACTIVE);
    if (!shouldRenderVariant) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: styles.wrapper, ref: wrapperRef }, { children: _jsx(WidgetFrame, { hasCarousel: false, title: popularPagesTitle, items: [
                _jsx("div", Object.assign({ className: styles.popularPagesContentWrapper }, { children: popularPagesElements.map((popularPage) => {
                        const { title, link, subtext, image, hasLongTitle, hasLongSubtext } = popularPage;
                        // attribution text is more important than title so always show it in 2 lines
                        const shouldPreferSubtextOverTitle = (!hasLongTitle && hasLongSubtext) || (hasLongTitle && hasLongSubtext);
                        return (_jsx(CardHorizontal, { textCardProps: {
                                title,
                                titleLink: link,
                                subtext,
                                onTitleClick: () => track.click({
                                    label: 'right-rail-popular-pages',
                                }),
                            }, imageCardProps: {
                                shape: 'square',
                                image: image,
                            }, isNarrow: Boolean(subtext), shouldPreferSubtextOverTitle: shouldPreferSubtextOverTitle }, void 0));
                    }) }), void 0),
            ] }, void 0) }), void 0));
};
export default NewPopularPagesModule;
